import { type HttpPatch, mapServerError } from '@/shared/infra/http'
import type { GalleryPhoto } from '@/shared/domain'
import {
  GalleryPhotoAccessDeniedError,
  GalleryPhotoNotFoundError,
} from '@/shared/domain'
import type { UpdateGalleryPhoto } from '@/modules/gallery/use-cases'

type UpdateGalleryPhotoBody = {
  caption?: string
  takenAt?: string
}

export class SupabaseUpdateGalleryPhotoRepository {
  constructor(private readonly http: HttpPatch) {}

  execute: UpdateGalleryPhoto = async ({ id, caption, takenAt }) => {
    const body: UpdateGalleryPhotoBody = {}
    if (caption !== undefined) body.caption = caption
    if (takenAt !== undefined) body.takenAt = takenAt

    try {
      const data = await this.http.patch<
        UpdateGalleryPhotoBody,
        { photo: GalleryPhoto }
      >({
        url: `/club-gallery-photos/${encodeURIComponent(id)}`,
        body,
      })
      return data.photo
    } catch (err) {
      mapServerError(err, {
        '403:access_denied': GalleryPhotoAccessDeniedError,
        '404:not_found': GalleryPhotoNotFoundError,
      })
    }
  }
}
